import { render, staticRenderFns } from "./quesShortAnswer.vue?vue&type=template&id=0f741be0"
import script from "./quesShortAnswer.vue?vue&type=script&lang=js"
export * from "./quesShortAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports